"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  size: 'medium'
};
var useStyles = (0, _styles.makeStyles)({
  small: {
    marginTop: -2,
    '& > .month': {
      fontWeight: 600,
      fontSize: 8,
      lineHeight: '8px'
    },
    ' & > .day': {
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '12px'
    }
  },
  medium: {
    '& > .month': {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '8px'
    },
    ' & > .day': {
      fontWeight: 700,
      fontSize: 24
    }
  },
  large: {
    marginTop: -2,
    '& > .month': {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '14px'
    },
    ' & > .day': {
      fontWeight: 700,
      fontSize: 32,
      lineHeight: '24px'
    }
  }
});

var DynamicEventIcon = function DynamicEventIcon(_ref) {
  var size = _ref.size;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: 'span',
    className: classes[size]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "month"
  }, (0, _moment.default)().format('MMM').toUpperCase()), /*#__PURE__*/_react.default.createElement("div", {
    className: "day"
  }, (0, _moment.default)().format('DD')));
};

DynamicEventIcon.defaultProps = defaultProps;
var _default = DynamicEventIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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